export default "__VITE_ASSET__df02c24f__"